<template>
  <div class="steps-container">
    <r-title>{{ $t('referral.page.steps.header') }}</r-title>
    <ul>
      <li>
        <div>
          <img src="/img/icons/invite.svg" />
        </div>
        <div class="text">{{ $t('referral.page.steps.step-0') }}</div>
      </li>
      <li>
        <div>
          <img src="/img/icons/join.svg" />
        </div>
        <div class="text" v-html="$t('referral.page.steps.step-1', { reward: referralReward })"></div>
      </li>
      <li>
        <div>
          <img src="/img/icons/get.svg" />
        </div>
        <div class="text" v-html="$t('referral.page.steps.step-2', { reward: referralReward })"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RTitle from '@/components/common/Title.vue';

export default {
  components: {
    RTitle,
  },
  computed: {
    ...mapGetters(['referralReward']),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';

.steps-container {
  padding: 5%;
}

ul {
  display: flex;
  list-style: none;
  padding: 0;
}

li {
  margin: 0 20px;
}

img {
  margin: 16px;
}

.text {
  width: 20vw;
  max-width: 300px;
  font-size: $font-size-large;
}
</style>
